import icon from "../../assets/radio-60g.svg";
import type { Property } from "../../types";

export const dedicatedSpectral: Property = {
  id: "radios",
  title: "dedicatedSpectral.title",
  icon,
};
